// Hero below drawer header — verdict, tags, kill chain; scrolls with drawer body.

import React from "react";
import PropTypes from "prop-types";
import { Box, Stack, Typography } from "@mui/material";
import { GitBranch } from "lucide-react";

import { PRIMARY_COLOR } from "../wafEventDrawerShared";
import EventStatusBanner from "./EventStatusBanner";
import KillChainBar from "./KillChainBar";
import {
  spHeroContentSx,
  spKillChainPanelSx,
  spSectionLabelSx,
} from "./smartParseDrawerUi";

export default function SmartParseDrawerHero({ event }) {
  if (!event) return null;

  const killChain = event.story?.kill_chain;

  return (
    <Box sx={spHeroContentSx}>
      <EventStatusBanner event={event} />

      {Array.isArray(killChain) && killChain.length > 0 && (
        <Box sx={{ ...spKillChainPanelSx, mt: 0 }}>
          <Stack sx={{ gap: "14px" }}>
            <Stack direction="row" alignItems="center" sx={{ gap: "8px" }}>
              <GitBranch size={13} color={PRIMARY_COLOR} strokeWidth={2.5} />
              <Typography sx={{ ...spSectionLabelSx, fontSize: 10, letterSpacing: "0.12em" }}>
                Kill chain
              </Typography>
            </Stack>
            <KillChainBar stages={killChain} />
          </Stack>
        </Box>
      )}
    </Box>
  );
}

SmartParseDrawerHero.propTypes = {
  event: PropTypes.object,
};
